<template>
    <section class="h-100">
        <front-table :front_page="page"
                     :front_records="records"
                     :front_search="search"
                     :front_header="header"
                     :model="model"
                     @reload="handleReload"
                     @edit="handleEdit"
                     :btn_copy="can_copy"
                     @copy="handleCopy"
        >
        </front-table>
        <!--编辑界面-->
        <edit-dialog :edit_mode="edit_mode" :model="model" :single="single" :fields="fields" dual
                     @success="handleSuccess" @cancel="handleCancel">
            <template slot="footer">
                <el-button slot="reference" class="pull-left" type="warning" size="small" plain @click="preview=true">
                    预览
                </el-button>
            </template>

            <el-dialog append-to-body v-mobile-dialog
                       :title="single.title"
                       :visible.sync="preview"
                       width="75%">
                <h4>{{single.title}}</h4>
                <p></p>
                <div v-html="single.text"></div>
                <span slot="footer" class="dialog-footer">
                    <el-checkbox v-model="ivread" class="pull-left" style="font-size: 24px;">我已阅读</el-checkbox>
                    <el-button type="primary" @click="preview=false">确 定</el-button>
                </span>
            </el-dialog>
        </edit-dialog>
        <div class="clearfix"></div>
    </section>
</template>

<script>
    import EditDialog from "../components/edit-dialog";
    import FrontTable from "../components/front-table";
    import FrontMixins from "../common/mixins/front-mixins";

    export default {
        mixins: [FrontMixins],
        name: 'admin-admin',
        components: {FrontTable, EditDialog},
        data(){
          return {
              ivread:false,
              preview:false
          }
        },
        created() {
            this.model = 'Admin.' + this.$route.meta.model;
        },
        computed: {
            can_copy() {
                return this.$route.meta ? this.$route.meta.copy : false;
            }
        }
    }

</script>

<style lang="scss">

</style>
